import { useState } from "react";
import loginLogo from "../../assets/logiscreen.png";
import { Link, useNavigate } from "react-router-dom";
import api from "../../utils/api";
import { FiEye, FiEyeOff } from "react-icons/fi";

// Adjust this import path based on your project
const CustomerLogin = () => {
  const [activeTab, setActiveTab] = useState("signup");
  const [signupData, setSignupData] = useState({
    businessName: "",
    mobile: "",
    email: "",
    password: "",
  });

  const [loginData, setLoginData] = useState({
    email_or_mobile: "",
    password: "",
  });

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // Handle input changes
  const handleSignupChange = (e) => {
    const { name, value } = e.target;
    setSignupData((prev) => ({ ...prev, [name]: value }));
  };

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prev) => ({ ...prev, [name]: value }));
  };

  // Signup Submit
  const handleSignupSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const res = await api.post("/auth/signup", signupData);
    setLoading(false);

    if (res.success) {
      localStorage.setItem("is_authenticated", "true");
      navigate("admin/dashboard"); // Redirect on success
    } else {
      setError(res.error.message || "Signup failed.");
    }
  };

  // Login Submit
  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await api.post("admin/sign-in", loginData);
      setLoading(false);

      if (res.success) {
        // No need to store token manually – backend sets HttpOnly cookie
        localStorage.setItem("userDatas", JSON.stringify(res?.data));
        // set token only on development
        localStorage.setItem("is_authenticated", "true");
        navigate("/admin/dashboard"); // Redirect on success
      } else {
        setError(res.error?.message || "Login failed.");
      }
    } catch (err) {
      setLoading(false);
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="h-screen w-screen overflow-hidden bg-white md:bg-white">
      {/* ✅ Desktop View */}
      <div className="hidden md:flex flex-row items-center justify-center h-screen p-8 bg-white">
        {/* Left: Logo */}
        <div className="md:w-1/2 w-full md:flex justify-center items-center">
          <img src={loginLogo} alt="Illustration" className="md:w-3/4" />
        </div>

        {/* Right: Form Section */}
        <div className="w-full md:w-1/2 max-w-md">
          {/* Tabs */}
          <div className="flex justify-center gap-4 mb-6">
            <button
              className={`px-4 py-2 font-semibold rounded-t-md ${
                activeTab === "signup"
                  ? "border-b-2 border-primary text-primary"
                  : "border-b-2 border-gray-200 text-gray-600"
              }`}
              onClick={() => setActiveTab("signup")}
            >
              Sign Up
            </button>
            <button
              className={`px-4 py-2 font-semibold rounded-t-md ${
                activeTab === "login"
                  ? "border-b-2 border-primary text-primary"
                  : "border-b-2 border-gray-200 text-gray-600"
              }`}
              onClick={() => setActiveTab("login")}
            >
              Login
            </button>
          </div>

          {/* Forms */}
          <div className="p-6 rounded-b-md">
            {error && <p className="text-red-500 text-center mb-2">{error}</p>}
            {activeTab === "signup" ? (
              <>
                <h2 className="text-xl font-bold mb-4 text-center">
                  Create Account
                </h2>
                <form className="space-y-3" onSubmit={handleSignupSubmit}>
                  <input
                    type="text"
                    name="businessName"
                    placeholder="Business Name"
                    value={signupData.businessName}
                    onChange={handleSignupChange}
                    autoComplete="off"
                    className="w-full border p-2 rounded-md"
                  />
                  <input
                    type="tel"
                    name="mobile"
                    placeholder="Mobile Number"
                    value={signupData.mobile}
                    onChange={handleSignupChange}
                    autoComplete="off"
                    className="w-full border p-2 rounded-md"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={signupData.email}
                    onChange={handleSignupChange}
                    autoComplete="off"
                    className="w-full border p-2 rounded-md"
                  />
                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Password"
                      value={signupData.password}
                      onChange={handleSignupChange}
                      autoComplete="new-password"
                      className="w-full border p-2 rounded-md pr-10"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                    >
                      {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                    </button>
                  </div>
                  <button
                    type="submit"
                    className="w-full bg-primary font-semibold text-white py-2 rounded-md"
                    disabled={loading}
                  >
                    {loading ? "Registering..." : "Register"}
                  </button>
                </form>
                <button className="w-full text-primary mt-4 border shadow-lg font-semibold py-2 rounded-md text-sm">
                  Sign up with Google
                </button>
              </>
            ) : (
              <>
                <h2 className="text-xl font-bold mb-4 text-center">Login</h2>
                <form className="space-y-3" onSubmit={handleLoginSubmit}>
                  <input
                    type="text"
                    name="email_or_mobile"
                    placeholder="Email or Mobile Number"
                    value={loginData.email_or_mobile}
                    onChange={handleLoginChange}
                    autoComplete="off"
                    className="w-full border p-2 rounded-md"
                  />

                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Password"
                      value={loginData.password}
                      onChange={handleLoginChange}
                      autoComplete="new-password"
                      className="w-full border p-2 rounded-md pr-10"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                    >
                      {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                    </button>
                  </div>
                  <div className="text-right">
                    <Link
                      to="/forgotpassword"
                      className="text-primary text-right"
                    >
                      Forgot Password?
                    </Link>
                  </div>

                  <button
                    type="submit"
                    className="w-full block text-center bg-primary text-white py-2 rounded-md"
                    disabled={loading}
                  >
                    {loading ? "Logging in..." : "Login"}
                  </button>
                </form>
                <button className="w-full mt-4 shadow-lg border py-2 rounded-md text-sm">
                  Login with Google
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* ✅ Mobile View */}
      <div className="md:hidden relative h-full w-full">
        {/* Background Image */}
        <div
          className="absolute inset-0 z-0 w-full h-full"
          style={{
            backgroundImage: `url(${loginLogo})`,
            backgroundSize: "contain",
            backgroundPosition: "top center",
            backgroundRepeat: "no-repeat",
          }}
        />

        {/* Black overlay */}
        <div className="absolute inset-0 bg-black opacity-70 z-0" />

        {/* Bottom Popup */}
        <div className="absolute bottom-0 left-0 right-0 z-20 bg-white rounded-t-3xl px-6 pt-4 pb-6 shadow-2xl max-h-[80%] overflow-y-auto">
          <div className="w-14 h-1.5 bg-gray-300 rounded-full mx-auto mb-4" />

          {/* Tabs */}
          <div className="flex justify-center gap-4 mb-4">
            <button
              className={`px-4 py-2 font-semibold rounded-t-md ${
                activeTab === "signup"
                  ? "border-b-2 border-primary text-primary"
                  : "border-b-2 border-gray-200 text-gray-600"
              }`}
              onClick={() => setActiveTab("signup")}
            >
              Sign Up
            </button>
            <button
              className={`px-4 py-2 font-semibold rounded-t-md ${
                activeTab === "login"
                  ? "border-b-2 border-primary text-primary"
                  : "border-b-2 border-gray-200 text-gray-600"
              }`}
              onClick={() => setActiveTab("login")}
            >
              Login
            </button>
          </div>

          {/* Form content */}
          <div className="pt-2">
            {error && <p className="text-red-500 text-center mb-2">{error}</p>}
            {activeTab === "signup" ? (
              <>
                <h2 className="text-xl font-bold mb-4 text-center">
                  Create Account
                </h2>
                <form className="space-y-3" onSubmit={handleSignupSubmit}>
                  <input
                    type="text"
                    name="businessName"
                    placeholder="Business Name"
                    value={signupData.businessName}
                    onChange={handleSignupChange}
                    autoComplete="off"
                    className="w-full border p-2 rounded-md"
                  />
                  <input
                    type="tel"
                    name="mobile"
                    placeholder="Mobile Number"
                    value={signupData.mobile}
                    onChange={handleSignupChange}
                    autoComplete="off"
                    className="w-full border p-2 rounded-md"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={signupData.email}
                    onChange={handleSignupChange}
                    autoComplete="off"
                    className="w-full border p-2 rounded-md"
                  />
                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Password"
                      value={signupData.password}
                      onChange={handleSignupChange}
                      autoComplete="new-password"
                      className="w-full border p-2 rounded-md pr-10"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                    >
                      {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                    </button>
                  </div>
                  <button
                    type="submit"
                    className="w-full bg-primary font-semibold text-white py-2 rounded-md"
                    disabled={loading}
                  >
                    {loading ? "Registering..." : "Register"}
                  </button>
                </form>
                <button className="w-full text-primary mt-4 border shadow-lg font-semibold py-2 rounded-md text-sm">
                  Sign up with Google
                </button>
              </>
            ) : (
              <>
                <h2 className="text-xl font-bold mb-4 text-center">Login</h2>
                <form className="space-y-3" onSubmit={handleLoginSubmit}>
                  <input
                    type="text"
                    name="email_or_mobile"
                    placeholder="Email or Mobile Number"
                    value={loginData.email_or_mobile}
                    onChange={handleLoginChange}
                    autoComplete="off"
                    className="w-full border p-2 rounded-md"
                  />

                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Password"
                      value={loginData.password}
                      onChange={handleLoginChange}
                      autoComplete="new-password"
                      className="w-full border p-2 rounded-md pr-10"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                    >
                      {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                    </button>
                  </div>
                  <div className="text-right">
                    <Link
                      to="/forgotpassword"
                      className="text-primary text-right"
                    >
                      Forgot Password?
                    </Link>
                  </div>

                  <button
                    type="submit"
                    className="w-full block text-center bg-primary text-white py-2 rounded-md"
                    disabled={loading}
                  >
                    {loading ? "Logging in..." : "Login"}
                  </button>
                </form>
                <button className="w-full mt-4 shadow-lg border py-2 rounded-md text-sm">
                  Login with Google
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerLogin;
